import { Pipe, PipeTransform } from '@angular/core';

const MIN_CHARACTERS_TO_SHOW = 2;

@Pipe({
  name: 'shortEmail',
})
export class ShortEmailPipe implements PipeTransform {
  transform(email: string) {
    if (!email || !email.includes('@')) {
      return email;
    }

    const [localPart, domain] = email.split('@');

    if (localPart.length <= MIN_CHARACTERS_TO_SHOW) {
      return `${localPart}***@${domain}`;
    }

    const firstTwo = localPart.substring(0, MIN_CHARACTERS_TO_SHOW);

    return `${firstTwo}***@${domain}`;
  }
}
